const documentCenter = {
  'documentCenter_易仓文档中心为开发者提供更优质的文档服务': {
    cn: '易仓科技文档中心为开发者提供更优质的文档服务以及FAQ查询，方便开发者快速查找集成相关问题',
    en: 'The document center of ECCANG supplies better document service and FAQ query, for developers to search related problems in integration quickly ',
    kr: ''
  },
  'documentCenter_仓文档中心为开发者提供更优质的文档服务': {
    cn: '请输入关键词进行搜索，例如：常见问题',
    en: 'Enter keywords for searching , for example: general questions',
    kr: ''
  },
  'documentCenter_请求方法': { cn: '请求方法：', en: 'Request method:', kr: '' }
}

export default {
  ...documentCenter
}
